"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AFTO781V1Data = exports.AFTO781V1DataCertification = exports.AFTO781V1DataARMSAudit = exports.AFTO781V1DataARMSInput = void 0;
const base_model_1 = require("../../base-model");
const afto_781_v1_data_schema_1 = require("./afto_781_v1-data.schema");
class AFTO781V1DataARMSInput extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_data_schema_1.afto781V1DataARMSInputSchema;
    }
}
exports.AFTO781V1DataARMSInput = AFTO781V1DataARMSInput;
class AFTO781V1DataARMSAudit extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_data_schema_1.afto781V1DataARMSAuditSchema;
    }
}
exports.AFTO781V1DataARMSAudit = AFTO781V1DataARMSAudit;
class AFTO781V1DataCertification extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return afto_781_v1_data_schema_1.afto781V1DataCertificationSchema;
    }
}
exports.AFTO781V1DataCertification = AFTO781V1DataCertification;
class AFTO781V1Data extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {
            missionData: [],
            aircrewData: [],
        };
    }
    getSchema() {
        return afto_781_v1_data_schema_1.afto781V1DataSchema;
    }
}
exports.AFTO781V1Data = AFTO781V1Data;
